import React from 'react'
import './HomeIptvList.scss'

/*
  Строка списка категорий. Кнопка, а не div: переключается с клавиатуры,
  состояние отдаётся через aria-pressed.
  Иконок в строке нет — только название, прижатое к правому краю.
*/
const HomeIptvList = ({ title, active, onSelect }) => {
  return (
    <button
      type="button"
      className={'homeIptvList_block' + (active ? ' homeIptvList_block--active' : '')}
      aria-pressed={active}
      onClick={onSelect}
    >
      <span className="homeIptvList_text">{title}</span>
    </button>
  )
}

export default HomeIptvList
